/**
 * Mode routing, and nothing else.
 *
 * There is no router library. The only URL this app cares about is `/t/CODE`,
 * which a shared link produces — landing on one drops you straight into the
 * online mode with the code already filled in, because a link that makes you
 * find the join screen yourself is a link that does not get used.
 */

import { useState } from 'react';
import { Home, type Mode } from './screens/Home';
import { Scorekeeper } from './keeper/Scorekeeper';
import { SoloGame } from './solo/SoloGame';
import { RemoteGame } from './remote/RemoteGame';
import { storedName } from './net/socket';

const deepLinked = /^\/t\/[A-Za-z0-9]{4,6}\/?$/.test(location.pathname);

export function App() {
  const [mode, setMode] = useState<Mode | null>(deepLinked ? 'online' : null);
  const home = () => setMode(null);

  switch (mode) {
    case 'online':
      return <RemoteGame onExit={home} />;
    case 'solo':
      return <SoloGame onExit={home} name={storedName()} />;
    case 'keeper':
      return <Scorekeeper onExit={home} />;
    default:
      return <Home onPick={setMode} />;
  }
}
